export default __webpack_public_path__ + "static/media/safecheckout.e27a706e.png";